﻿(function ($) {
    /**
     * Function for registering the initialising of interactive map
     *
     * @return {void} Nothing
     *
     */
    $(document).ready(function () {
        const $map = $('.interactiveMap__map');

        if ($map.length) {
            intialiseInteractiveMapButtons($map);
            initialiseInteractiveMap($map);
        }
    });

    /**
     * Function for initialising the interactive map
     *
     * @param {jQuery} map - Interactive map element
     * @return {void} Nothing
     *
     */
    function initialiseInteractiveMap(map) {
        console.log('Map detected!', map)

        const $interactiveRegions = $('.interactiveMap__region');

        const activeClass = 'interactiveMap__region--active';
        const $buttons = $('.interactiveMap__buttons');

        $('.interactiveMap__region').hover(
            function onMouseIn() {
                const region = $(this).attr('data-region');

                map.addClass('interactiveMap--fadeUnselectedRegions');

                map.find(`[data-region="${region}"]`).addClass(activeClass);
                $buttons.find(`[data-region="${region}"]`).addClass(activeClass);

            },
            function onMouseOut() {           
                const region = $(this).attr('data-region');

                map.removeClass('interactiveMap--fadeUnselectedRegions');

                map.find(`[data-region="${region}"]`).removeClass(activeClass);
                $buttons.find(`[data-region="${region}"]`).removeClass(activeClass);

            }
        );

        $('.interactiveMap__region').click(function () {
            const region = $(this).attr('data-region');

            const url = $buttons.find(`[data-region="${region}"]`).prop('href');

            window.open(url, '_blank');
           // location.href = url;
        });

    }

    /**
     * Function for initialising the interactive map buttons
     *
     * @param {jQuery} map - Interactive map element
     * @return {void} Nothing
     *
     */
    function intialiseInteractiveMapButtons(map) {
        const $interactiveButton = $('.interactiveMap__buttons').find('.interactiveMap__button');
        

        $interactiveButton.hover(
            function onMouseIn() {
                console.log('hover');
                const region = $(this).attr('data-region');

                map.addClass('interactiveMap--fadeUnselectedRegions');
     
                const $mapRegions = map.find(`[data-region="${region}"]`);
                $mapRegions.addClass('interactiveMap__region--active');
            },
            function onMouseOut() {
                const region = $(this).attr('data-region');

                map.removeClass('interactiveMap--fadeUnselectedRegions');

                const $mapRegions = map.find(`[data-region="${region}"]`);
                $mapRegions.removeClass('interactiveMap__region--active');
            }
        );
    }
})(jQuery);